module.exports = __webpack_public_path__ + "static/img/quanliucheng_03.1251fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanliucheng_03.png
// module id = z0Sk
// module chunks = 1